import { Component, OnDestroy, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import * as moment from "moment";
import { Observable, Subscription } from "rxjs";
import { VerificacionRutValidator } from "src/app/directives/verifica-rut.directive";
import { DatosCreacionBhe } from "src/app/models/BoletaHonorarios/DatosCreacionBhe";
import { ReceptorBhe } from "src/app/models/BoletaHonorarios/ReceptorBhe";
import { Comuna } from "src/app/models/Region/Comuna";
import { Region } from "src/app/models/Region/Region";
import { EmisionBheService } from "src/app/services/emision-bhe.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { UtilitiesService } from "src/app/services/utilities.service";
import { threadId } from "worker_threads";
import { SessionUserService } from 'src/app/modules/auth/session-user/session-user.service';

@Component({
	selector: "app-receptor-bhe",
	templateUrl: "./receptor-bhe.component.html",
	styleUrls: ["./receptor-bhe.component.scss"],
})
export class ReceptorBheComponent implements OnInit, OnDestroy {
	public receptorBheFormGroup: FormGroup;
	regionesSource: Region[] = this.localStorage.getRegiones();
	comunasSource: Comuna[] = []; //this.localStorage.getComunas();
	datosCreacion: DatosCreacionBhe = new DatosCreacionBhe();
	receptorAsociado: ReceptorBhe = new ReceptorBhe();
	//private retencionSubscription$: Observable<boolean>;
	//private isTerceros$: Observable<boolean>;
	//private subs: Subscription[] = [];

	public todayString = moment();
	locale = {
		daysOfWeek: moment.weekdaysMin(),
		monthNames: moment.monthsShort(),
		firstDay: moment.localeData().firstDayOfWeek(),
		applyLabel: "ok",
		clearLabel: "Limpiar",
		format: "DD/MM/YYYY",
	};
	constructor(private localStorage: LocalStorageService, private formBuilder: FormBuilder, private emisionBheService: EmisionBheService, private utilities: UtilitiesService, private sessionUserService: SessionUserService) {
		this.datosCreacion.receptorBhe = this.receptorAsociado;
		//this.regionesSource.sort((a, b) => b.codigoSii - a.codigoSii);
		this.utilities.sortAlphabeth(this.regionesSource, "nombre");
		this.setReceptorForm();
		//this.retencionSubscription$ = this.emisionBheService.retencionReceptorObservable;
	}

	ngOnInit(): void {
		// this.retencionSubscription$.subscribe((retencion) => {
		// 	this.datosCreacion.retencionEmisor = retencion;
		// 	this.onSubmit();
		// });
		//this.subs.push(this.retencionSubscription);
		this.sessionUserService.verificarSesionUsuario();
	}

	setReceptorForm() {
		this.receptorBheFormGroup = this.formBuilder.group({
			fechaEmision: [{ startDate: moment(), endDate: moment() }, Validators.required],
			rutReceptor: ["", [Validators.required, VerificacionRutValidator]],
			nombreReceptor: [, Validators.required],
			domicilio: [, Validators.required],
			region: [, Validators.required],
			comuna: [, Validators.required],
			retencionEmisor: [false],
		});
	}

	onSubmit() {
		if (this.receptorBheFormGroup.valid) {
			this.formDataToRequest();
			this.emisionBheService.setDatosReceptor(this.datosCreacion);
		}
		// } else {
		// 	this.emisionBheService.setDatosReceptor(undefined);
		// }
	}

	onRegionChange(event: Region) {
		//let comunasOfRegion = this.comunasSource.filter(comuna=> comuna.regionId == event.regionId);
		this.utilities.sortAlphabeth(event.comunas, "nombre");
		let comunas = event.comunas;
		this.comunasSource = comunas;
		this.f().comuna.patchValue(this.comunasSource[0]);
		this.onSubmit();
	}

	onComunaChange(event) {
		this.onSubmit();
	}

	detectChangeDate(event) {
		this.receptorBheFormGroup.controls.fechaEmision.patchValue(event);
	}

	f() {
		return this.receptorBheFormGroup.controls;
	}
	formDataToRequest() {
		let date = this.f().fechaEmision.value;
		this.datosCreacion.fechaEmision = moment(date.startDate).toDate();
		let rut = this.f().rutReceptor.value;
		this.datosCreacion.receptorBhe.rutStringReceptor = rut;
		this.datosCreacion.receptorBhe.rutReceptor = parseInt(rut.includes("-") ? rut.substring(0, rut.length - 2) : rut.substring(0, rut.length - 1));
		this.datosCreacion.receptorBhe.dvReceptor = rut.substring(rut.length - 1);
		this.datosCreacion.receptorBhe.nombreReceptor = this.f().nombreReceptor.value;
		this.datosCreacion.receptorBhe.direccionReceptor = this.f().domicilio.value;
		let region: Region = this.f().region.value;
		let comuna: Comuna = this.f().comuna.value;
		this.datosCreacion.receptorBhe.regionReceptor = region.nombre;
		this.datosCreacion.receptorBhe.codigoRegionReceptor = region.codigoSii;
		this.datosCreacion.receptorBhe.comunaReceptor = comuna.nombre;
		this.datosCreacion.receptorBhe.codigoComunaReceptor = comuna.codigoSii;
		this.datosCreacion.retencionEmisor = this.f().retencionEmisor.value;
	}
	changeRetencionEmisor(event) {
		this.f().retencionEmisor.patchValue(event.target.checked);
		this.onSubmit();
	}

	ngOnDestroy() {
		//this.retencionSubscription.unsubscribe();
	}
}
